import { render } from "./List.vue?vue&type=template&id=229acb06&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=229acb06&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-229acb06"

export default script